module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("兑换记录")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 60,
      "show-message": false,
      "lable-positon": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "uid"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名",
      "label-width": 75
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "userNickname"
    },
    model: {
      value: (_vm.queryParam.userNickname),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "userNickname", $$v)
      },
      expression: "queryParam.userNickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "兑换类型"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.type),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "type", _vm._n($$v))
      },
      expression: "queryParam.type"
    }
  }, _vm._l((_vm.$constant.giveType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "操作人"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "checkAdmin"
    },
    model: {
      value: (_vm.queryParam.auditorName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "auditorName", $$v)
      },
      expression: "queryParam.auditorName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 7
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "申请时间"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.startTimeDateChange
    },
    model: {
      value: (_vm.queryParam.startTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "startTimeDate", $$v)
      },
      expression: "queryParam.startTimeDate"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "1"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.endTimeDateChange
    },
    model: {
      value: (_vm.queryParam.endTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "endTimeDate", $$v)
      },
      expression: "queryParam.endTimeDate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 2
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n        ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/activityExamine/recordList",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d34c2e3","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/ExchangeRecordList.vue
// module id = 1726
// module chunks = 8